enum AuthRole {
    PUBLIC = 'public',
    UNAUTHENTICATED = 'unauthenticated',
    UNSUBSCRIBED = 'unsubscribed',
    PENDING_SUBSCRIPTION = 'pending',
    SUBSCRIBED = 'subscribed',
}

export { AuthRole };
